<template>
  <div id="app">
    <AppMenu
      v-if="!standalone"
      :route="route"
      @external-navigate="onExternalNavigate"
    />
    <StartPage v-if="!standalone && route === '/'" />
    <QuickstartPage v-else-if="!standalone && route === '/quickstart'" />
    <AboutPage v-else-if="!standalone && route === '/about'" />
    <div v-show="standalone || route === '/editor'" class="editor-wrapper">
      <GraphEditor ref="editor" :visible="standalone || route === '/editor'" />
    </div>
  </div>
</template>

<script>
import AppMenu from './components/AppMenu.vue'
import GraphEditor from './components/GraphEditor.vue'
import StartPage from './components/StartPage.vue'
import QuickstartPage from './components/QuickstartPage.vue'
import AboutPage from './components/AboutPage.vue'

function routeFromHash() {
  const hash = window.location.hash.replace(/^#/, '')
  return ['/editor', '/quickstart', '/about'].includes(hash) ? hash : '/'
}

export default {
  name: 'App',
  components: {
    AppMenu,
    GraphEditor,
    StartPage,
    QuickstartPage,
    AboutPage
  },
  data() {
    return {
      standalone: import.meta.env.VITE_STANDALONE === 'true',
      route: routeFromHash()
    }
  },
  mounted() {
    window.addEventListener('hashchange', this.onHashChange)
  },
  beforeUnmount() {
    window.removeEventListener('hashchange', this.onHashChange)
  },
  methods: {
    onHashChange() {
      this.route = routeFromHash()
    },
    onExternalNavigate() {
      const editor = this.$refs.editor
      if (editor && editor.hasUnsavedChanges) {
        const save = window.confirm(
          'Die aktuelle Karte hat ungespeicherte Änderungen.\n\n'
          + 'OK: Karte speichern und Seite verlassen\n'
          + 'Abbrechen: Seite verlassen ohne zu speichern'
        )
        if (save) {
          editor.saveNow()
        }
      }
    }
  }
}
</script>

<style>
#app {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.editor-wrapper {
  flex: 1;
  min-height: 0;
}
</style>
